export const netConfig = {
  timeout: 15000,
  successCode: 200,
  loginCode: [600, 601],
}
